import { Activity } from 'lucide-react'
import { money } from '../utils/format'
import { pathSummary } from '../utils/pathSummary'
import type { JournalPathPoint } from '../types'

const value = (number: number, digits: number) => number.toLocaleString('en-IN', { maximumFractionDigits: digits })

export function TradePathSummary({ path = [], isDemo = false }: { path?: JournalPathPoint[]; isDemo?: boolean }) {
  const summary = pathSummary(path)
  return (
    <section className="jn-panel" aria-label="During the trade">
      <header className="jn-panel-heading">
        <div className="flex items-center gap-2"><Activity size={14} className="text-primary" /><h3>During the trade</h3></div>
        <span className={isDemo ? 'jn-demo-badge' : 'jn-badge'}>{isDemo ? 'Demo samples' : summary ? `${path.length} samples` : 'No path data'}</span>
      </header>
      <dl className="jn-path-metrics">
        {/*
          PLAIN WORDS, with the textbook terms on the title. MAE and MFE are
          what the literature calls these and what nobody reading their own
          journal calls them — "how bad did it get" and "how good did it
          get" is the question actually being asked.
        */}
        <div><dt title="Maximum adverse excursion (MAE)">Max pain</dt><dd className="num text-destructive">{summary ? money(summary.mae) : '—'}</dd></div>
        <div><dt title="Maximum favourable excursion (MFE)">Best moment</dt><dd className="num text-success">{summary ? money(summary.mfe) : '—'}</dd></div>
        <div><dt>IV peak</dt><dd className="num">{summary ? `${(summary.ivPeak * 100).toFixed(1)}%` : '—'}</dd></div>
      </dl>
      {summary && <dl className="jn-path-greeks">
        {([
          ['Δ range', summary.delta, 2], ['Γ range', summary.gamma, 4],
          ['Θ / day', summary.theta, 0], ['ν / 1% IV', summary.vega, 0],
        ] as const).map(([label, range, digits]) => (
          <div key={label}><dt>{label}</dt><dd className="num">{value(range.low, digits)} <span>→</span> {value(range.high, digits)}</dd></div>
        ))}
      </dl>}
    </section>
  )
}
